module.exports = __webpack_public_path__ + "img/left.97a85ee0.png";